let arr = [
  {
    name_en: "Meme Grail Relic",
    name_zh: "米姆圣杯名残"
  },
  {
    name_en: "Vitalik Buterin Common",
    name_zh: "V神-普通版"
  },
  {
    name_en: "Vitalik Buterin Rare",
    name_zh: "V神-稀有卡",
  },
  {
    name_en: "Changpeng Zhao(CZ) Common",
    name_zh: "赵长鹏-普通",
  },
  {
    name_en: "Changpeng Zhao(CZ) Rare",
    name_zh: "赵长鹏-稀有卡",
  },
  {
    name_en: "Sergey Nazarov Common",
    name_zh: "Sergey-普通",
  },
  {
    name_en: "Sergey Nazarov Rare",
    name_zh: "Sergey-稀有卡"
  },
  {
    name_en: "Zeus Capital",
    name_zh: "宇宙宙斯神王"
  },
  {
    name_en: "Chef Nomi",
    name_zh: "大厨 Nomi",
  },
  {
    name_en: "IceBergy",
    name_zh: "北极冰儿",
  },
];

export default arr